import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const navLinks = [
  { href: "/", label: "Acasă" },
  { href: "/pachete", label: "Pachete" },
  { href: "/servicii", label: "Servicii" },
  { href: "/b2b", label: "B2B: Externalizare WP" },
  { href: "/despre", label: "Despre" },
  { href: "/faq", label: "FAQ" },
  { href: "/contact", label: "Contact" },
];

export default function Header() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/50 border-b border-[#0F2942]/10"
    >
      <div className="section-container flex items-center justify-between h-16 lg:h-18">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <img src={`${import.meta.env.BASE_URL}images/ordell-logo.png`} alt="Ordell WebCare" className="w-7 h-7" width="28" height="28" />
          <span className="font-['Outfit'] font-bold text-xl text-[#0F2942]">Ordell</span>
          <span className="font-['Outfit'] font-light text-xl text-[#1A4A40]">WebCare</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors ${
                location.pathname === link.href
                  ? "text-[#0F2942]"
                  : "text-[#1A1D20]/70 hover:text-[#0F2942]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <Link
            to="/contact"
            data-testid="header-cta-btn"
            className="hidden sm:inline-flex bg-[#0F2942] text-white font-medium text-sm px-5 py-2.5 rounded-xl hover:bg-[#0F2942]/90 transition-all"
          >
            Cere audit gratuit
          </Link>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                data-testid="mobile-menu-btn"
                className="lg:hidden p-2 text-[#1A1D20] hover:text-[#0F2942]"
              >
                <Menu className="w-5 h-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72 bg-white">
              <SheetTitle className="font-['Outfit'] text-[#0F2942]">Meniu</SheetTitle>
              <nav className="flex flex-col gap-4 mt-8">
                {navLinks.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                    className={`text-base font-medium py-2 transition-colors ${
                      location.pathname === link.href
                        ? "text-[#0F2942]"
                        : "text-[#1A1D20]/70 hover:text-[#0F2942]"
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  onClick={() => setOpen(false)}
                  data-testid="mobile-cta-btn"
                  className="mt-4 bg-[#0F2942] text-white font-medium text-sm px-5 py-3 rounded-xl text-center hover:bg-[#0F2942]/90 transition-all"
                >
                  Cere audit gratuit
                </Link>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
